<template lang="pug">
#report-summary.card-box
  .d-md-flex
    .p-2.mr-auto
      .m-b-10
        | {{ reportTitle }}
      h3.text-dark.site-title.m-t-m-b-30.d-flex
        span.align-self-center.d-flex.align-items-center
          | {{summary.title}}
          span.align-self-center.m-l-5.badge.badge-primary(v-if="titleBadges.lightfile")
            | {{ $t('usingLightFile') }}
          span.align-self-center.m-l-5.badge.badge-danger(v-if="titleBadges.webp")
            | {{ $t('usingWebp') }}

    .p-2.text-right
      .m-b-10
        DateTime(v-bind:dateTime="summary.time" locale="ja" v-if="summary.time")
      div
        MyVueGoodshare

  #report-summary-body.row.m-t-20
    .col-md-3.text-center
      Screenshot(v-bind:screenshotKey="summary.screenshot.s3Key")
      div
        span.badge.badge-dark
          template(v-if="summary.device == 'sp'")
            i.mdi.mdi-cellphone-iphone
            | {{ $t('SmartPhoneSite') }}
          template(v-else)
            i.mdi.idi-laptop
            | {{ $t('PCSite') }}
        | &nbsp;
      div
        a(v-bind:href="summary.url") {{summary.url}}

    .col-md-9
      ReportReview(v-bind:summary="summary")
      h4.text-dark.header-title.m-t-30.text-center {{ chartTitle }}
      ImageSizeChart(v-bind:summary="summary" v-bind:types="types" v-bind:simulations="simulations")
</template>

<i18n>
{
  "ja": {
    "reportSubTitle": "LightFileシミュレーションレポート",
    "usingWebp": "WebP導入済み",
    "usingLightFile": "画像軽量化済み"    
  }
}</i18n>

<style lang="scss">
.site-title {
  font-weight: bold;
}
</style>

<script>
import Screenshot from '@/components/common/Screenshot'
import ResourceTypeChart from '@/components/chart/ResourceTypeChart'
import ImageSizeChart from '@/components/chart/ImageSizeChart'
import ReportReview from '@/components/ReportReview'
import MyVueGoodshare from '@/components/MyVueGoodshare'
import DateTime from '@/components/common/DateTime'

export default {
  components: {
    Screenshot,
    ResourceTypeChart,
    ImageSizeChart,
    ReportReview,
    MyVueGoodshare,
    DateTime,
  },
  props: {
    types: {
      default: () => ['jpg', 'png', 'gif'],
      type: Array,
    },
    simulations: {
      default() {
        return ['orig', 'high', 'medium', 'low']
      },
      type: Array,
    },
    summary: Object,
    resources: Array,
  },
  computed: {
    reportTitle() {
      return this.$t(`simulations.${this.summary.intent}.reportTitle`)
    },
    chartTitle() {
      return this.$t(`simulations.${this.summary.intent}.chartTitle`)
    },
    titleBadges() {
      const badges = {}
      for (let r of this.resources) {
        if (!badges.lightfile && r.lightfile) badges.lightfile = true
        if (!badges.webp && r.webp) badges.webp = true
      }
      return badges
    },
  },
}
</script>
